module.exports = __webpack_public_path__ + "static/media/SharpSansNo1-Book.8352d73f.woff2";